import { COVER_PAGE_FRAMES } from './coverPage'

const HOME_SMART_ENERGY_FRAMES = JSON.parse(JSON.stringify(COVER_PAGE_FRAMES))

export const HOME_SMART_ENERGY_PAGE_ID = 'custom_home-smart-energy'

export const HOME_SMART_ENERGY_PAGE_DESIGN = {
  frames: HOME_SMART_ENERGY_FRAMES,
  name: 'Cover Page Style 2',
  id: HOME_SMART_ENERGY_PAGE_ID,
  type: 'main',
}
